const IS_SAFARI_REGEX = /^((?!chrome|android).)*safari/i;

const isSafari = (): boolean => {
  return IS_SAFARI_REGEX.test(navigator.userAgent);
};

export default isSafari;
